import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  Segment,
  Table,
  Checkbox,
  Button,
  Icon,
  Label,
  Header,
} from "semantic-ui-react";
import intl from 'react-intl';

export type PackageItem = {
  id: string;
  name: string;          // e.g. "Package A"
  price: number;         // THB (ไม่รวมภาษี)
  credit: number;        // จำนวน Credit ที่จะได้
  disabled?: boolean;    // for greyed-out rows if needed
};

type PackageSelectorProps = {
  meHealthPackageList: any;
  // items: PackageItem[];
  // vatNote?: string;      // e.g. "ไม่รวมภาษีมูลค่าเพิ่ม"
  onProceed?: () => void;
  languageUX: any;
  runSequence: any;
  BillingCarts: any;
};

const formatTHB = (n: number) =>
  n.toLocaleString("th-TH", { style: "currency", currency: "THB" });

export default function PackageSelector(props: PackageSelectorProps) {
  const [selected, setSelected] = useState<any>({}); // id -> qty

  const [disabled, setDisabled] = useState(false);
  // const [activePackages, setActivePackages] = useState<any>([]);

  // const toggleSelect = (id: string, presetQty = 1) =>
  //   setSelected((s) => {
  //     const next = { ...s };
  //     if (next[id]) { 
  //       next[id].checked = !next[id].checked
  //     } else { 
  //       next[id] = { 
  //         quantity: presetQty, 
  //         checked: true
  //       }
  //     }
  //     return next;
  //   });

  const setQty = (id: string, qty: number) => { 
    setSelected((s) => {
      const q = Math.max(1, qty);
      return { 
        ...s, 
        [id]: q
      };
    });
  }
    
  useEffect(() => {
    let sel:any = {}
    props.meHealthPackageList?.items?.forEach((i: any) => { 
      sel[i.id] = 1
    })
    setSelected(sel)

  }, [props.meHealthPackageList?.items])
  

  const inc = (id: string) => setQty(id, (selected[id] || 1) + 1);
  const dec = (id: string) => setQty(id, (selected[id] || 1) - 1);


  const handleProceed = () => props.onProceed?.()

  // console.log('props.BillingCarts: ', props.BillingCarts);

  let sumTotals = (Array.isArray(props.BillingCarts?.items) ? props.BillingCarts?.items : [])
    ?.filter((i: any) => i.status === "BILLED" )
    ?.reduce((sum: number, obj: any) => sum + Number(obj?.price_included_vat.replace(/,/g, '')), 0)
  // console.log('props.BillingCarts: ', props.BillingCarts);
  // console.log('sumTotals: ', sumTotals);

  let sumQty = props.BillingCarts?.items?.filter((i: any) => i.status === "BILLED")?.reduce((accumulator, currentValue) => { return accumulator + (Number(currentValue?.quantity.replace(/,/g, "")) || 0) }, 0)


  return (
    <Grid stackable columns={2}>
      {/* Left column: table */}
      <Grid.Column width={11}>
        <Segment raised style={{ borderRadius: 14, padding: 0, overflow: "hidden" }}>
          <Table basic="very" celled={false} compact="very" style={{ margin: 0 }}>
            <Table.Header>
              <Table.Row
                style={{
                  background: "rgba(233,30,99,.12)",
                  borderBottom: "1px solid rgba(0,0,0,.06)",
                }}
              >
                <Table.HeaderCell width={4} style={{ fontWeight: 600, padding: "12px 16px" }}>
                  Package List
                  {/* <Checkbox label="Package List" onClick={(e, {checked}) => {
                    let s: any = {}
                    let ids = props.meHealthPackageList?.items?.filter((i: any) => i.active_flag !== "INACTIVE").map((i: any) => i.id)
                    if (checked) {
                      // select all 
                      for (const id of ids) {
                        if (selected[id]) {
                          selected[id].checked = true
                        }
                        s[id] = {
                          ...(selected[id] ? selected[id] : { count: 1, checked: true} )
                        }
                      }

                    } else {
                      // deselect all 
                      for (const id of ids) {
                        if (selected[id]) {
                          selected[id].checked = false
                        }
                        s[id] = {
                          ...(selected[id] ? selected[id] : { count: 1, checked: false} )
                        }
                      }
                    }
                    setSelected(s)
                  }}/> */}
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={3}
                  textAlign="right"
                  style={{ fontWeight: 600, padding: "12px 16px" }}
                >
                  ราคา<br/><span style={{ color: "#e91e63" }}>* {"ไม่รวมภาษีมูลค่าเพิ่ม"}</span>
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" width={3} style={{ fontWeight: 600, padding: "12px 16px" }}>
                  จำนวน Credit ที่จะได้
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={{ fontWeight: 600, padding: "12px 16px" }}
                >
                  จำนวน
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={3}
                  textAlign="center"
                  style={{ fontWeight: 600, padding: "12px 16px" }}
                >

                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {(props.meHealthPackageList?.items || []).map((it: any) => {
                // console.log("it", it)
                const checked = Boolean(selected?.[it.id]?.checked);
                const qty = selected?.[it.id] || 0
                return (
                  <Table.Row
                    key={it.id}
                    disabled={it.disabled}
                    style={{
                      opacity: it.disabled ? 0.45 : 1,
                      background: checked ? "rgba(233,30,99,.04)" : "transparent",
                    }}
                  >
                    {/* Package name + checkbox */}
                    <Table.Cell >
                      <div style={{ display: "flex", alignItems: "center", gap: 10, paddingLeft: "16px" }}>
                        { props.languageUX === "en" && it.name_en ? it.name_en : it.name }
                        {/* <Checkbox
                          checked={checked}
                          disabled={it.disabled}
                          onChange={() => toggleSelect(it.id)}
                          label={props.languageUX === "en" && it.name_en ? it.name_en : it.name}
                        /> */}
                      </div>
                    </Table.Cell>

                    {/* Price */}
                    <Table.Cell textAlign="right" style={{ color: "rgba(0,0,0,.5)" }}>
                      {it.price?.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      &nbsp;บาท
                    </Table.Cell>

                    {/* Credit (green chip like screenshot) */}
                    <Table.Cell textAlign="center">
                      <Label
                        basic
                        color="green"
                        style={{
                          borderColor: "rgba(76,175,80,.35)",
                          background: "rgba(76,175,80,.08)",
                          fontWeight: 700,
                        }}
                      >
                        {it.credit_amount?.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                      </Label>
                    </Table.Cell>

                    {/* Qty stepper + “เพิ่มไปยังรายการที่เลือก” */}
                    <Table.Cell textAlign="center">
                      <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center" }}>
                        <Button
                          icon="minus"
                          size="mini"
                          basic
                          // disabled={!checked || qty <= 1}
                          onClick={() => dec(it.id)}
                        />
                        <div style={{ minWidth: 24, textAlign: "center", fontWeight: 600 }}>{qty}</div>
                        <Button
                          icon="plus"
                          size="mini"
                          basic
                          // disabled={!checked}
                          onClick={() => inc(it.id)}
                        />

                      </div>
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        size="tiny"
                        color="pink"
                        basic
                        disabled={disabled}
                        onClick={ async () => {
                          setDisabled(true)
                          await props.runSequence({
                            sequence: "BillingAndPackage",
                            action: "ADD_TO_CART",
                            id: it.id,
                            quantity: selected?.[it.id]
                          })
                          setDisabled(false)
                        }}
                      >
                        เพิ่มไปยังรายการที่เลือก
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </Segment>
      </Grid.Column>

      {/* Right column: summary */}
      <Grid.Column width={5}>
        <Segment raised style={{ borderRadius: 14 }}>
          <Header as="h4" style={{ marginTop: 0 }}>
            สรุปรายการที่เลือก
          </Header>

          <Table basic="very" compact="very">
            <Table.Body>
              <Table.Row>
                <Table.Cell>ยอดรวมจำนวน Package</Table.Cell>
                <Table.Cell textAlign="right">{sumQty}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>ยอดรวม</Table.Cell>
                <Table.Cell textAlign="right">{formatTHB(sumTotals)}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          <div style={{ color: "rgba(0,0,0,.4)", marginTop: -6 }}>
            * ยังไม่รวมภาษีมูลค่าเพิ่ม
          </div>

          <Button
            fluid
            color="pink"
            size="large"
            style={{ marginTop: 16, borderRadius: 999 }}
            onClick={handleProceed}
            disabled={sumTotals === 0}
            icon
            labelPosition="right"
          >
            ดำเนินการต่อ
            <Icon name="arrow right" />
          </Button>
        </Segment>
      </Grid.Column>
    </Grid>
  );
}